/** Category filter, only interactive while the Projects view is up. */
export default function CategoryNav({ categories, active, onSelect, shown }) {
    return (
        <nav
            style={{
                position: 'absolute',
                left: '190px',
                bottom: '60px',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                pointerEvents: shown ? 'auto' : 'none',
                opacity: shown ? 1 : 0,
                transform: shown ? 'translateX(0)' : 'translateX(-6px)',
                transition: 'opacity .4s ease, transform .4s ease',
            }}
        >
            {categories.map((c) => (
                <div
                    key={c}
                    onClick={() => onSelect(c)}
                    style={{ cursor: 'pointer', width: 'max-content' }}
                >
                    <span
                        style={{
                            fontSize: '13px',
                            fontWeight: 600,
                            letterSpacing: '.01em',
                            color: active === c ? 'var(--accent)' : 'inherit',
                            opacity: active === c ? 1 : 0.4,
                            transition: 'opacity .3s ease, color .3s ease',
                        }}
                    >
                        {c}
                    </span>
                </div>
            ))}
        </nav>
    );
}
